export default __webpack_public_path__ + "static/media/Tiger's Helm of the Painted Claw.e8e5e390.jpg";